import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./index.css";
import App from "./App";
import { startEmbedResize } from "./utils/embedResize";
import { BrowserRouter, HashRouter } from "react-router-dom";

// On the VSGA website the app is loaded by embed.js into <div id="vsga-vip-app"> on a HubSpot page.
// The steps then live after a "#" (vsga.org/vip-card#/step2), so HubSpot never sees those paths.
const embedTarget = document.getElementById("vsga-vip-app");
const Router = embedTarget ? HashRouter : BrowserRouter;

const root = ReactDOM.createRoot(
  embedTarget ?? (document.getElementById("root") as HTMLElement)
);

root.render(
    <Router>
      <App />
    </Router>

);

startEmbedResize();
